import React, { useState } from "react";
import { useStateContext } from '../../contexts/ContextProvider';
import { Toaster, toast } from 'react-hot-toast';
import CardPlanesServicios from "../../components/Cards/CardPlanesServicios";
import { fetchUser } from '../../utils/fetchUser';
import { modificaRegistroPlan } from '../../services/RegistroPlanes'; // Asegúrate de importar la función correcta

const PlanesServicios = () => {
  const { currentColor } = useStateContext();
  const [seleccionados, setSeleccionados] = useState([]);
  const userInfo = fetchUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (seleccionados.length === 0) {
      toast.error("Debe seleccionar al menos un plan");
      return;
    }

    // Aquí podrías hacer una llamada a la API para guardar los planes seleccionados
    const data = {
      empresa: userInfo.empresa,
      idCliente: userInfo.usuario,
      planes: seleccionados,
    }

    await modificaRegistroPlan(data);  // Asegúrate de importar esta función desde tu servicio

    // Aquí va tu lógica de envío a API
    toast.success("Planes guardados correctamente");
    console.log("Guardando planes:", seleccionados);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="m-2 md:m-10 mt-16 p-4 bg-gray-100 rounded-3xl">
        <div className="container mx-auto">
          <div className="flex justify-between items-center px-4 py-4 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-green-800 animate-pulse" />
              <p className="text-gray-800 font-semibold text-lg">Planes y Servicios</p>
            </div>
          </div>

          <div className="bg-gray-100 p-6 mt-4 rounded-lg shadow-inner">
            <CardPlanesServicios onSelectionChange={setSeleccionados} />
          </div>

          <div className="text-right mt-6">
            <button
              type="submit"
              style={{ backgroundColor: currentColor }}
              className="text-white px-6 py-2 rounded-lg shadow"
            >
              Grabar Selección
            </button>
          </div>

          <Toaster position="top-right" toastOptions={{ style: { zIndex: 9999 } }} />
        </div>
      </div>
    </form>
  );
};

export default PlanesServicios;

